import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalTitle: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "18px",
            color: theme.palette.info.main,
            padding: "10px 30px",
            borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        },
    },
    bodyContainer: {
        overflowY: "auto",
        maxHeight: "90vh",
    },
}));

const baseModalStyles = {
    position: "absolute" as "absolute",
    left: "50%",
    width: "790px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    padding: 0,
    borderRadius: "4px",
};

export const getModalStyles = (alignTop: boolean) => ({
    ...baseModalStyles,
    ...(alignTop
        ? {
              top: "8%",
              transform: "translateX(-50%)",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
          }
        : {
              top: "50%",
              transform: "translate(-50%, -50%)",
          }),
});
